export ScrollTop from './ScrollTop';



// WEBPACK FOOTER //
// ../src/client/components/scroll/index.js